<div class="ap-container">
  @if (country().countryId) {
    <h2>
      {{ country().name }} -
      {{ 'countryInformation.taxNews' | translate }}
    </h2>
    <div class="d-flex justify-content-between mt-3">
      <div class="col-3">
        <form [formGroup]="dateForm">
          <gstar-datepicker
            [disabled]="isDateDisabled"
            [label]="'shared.date' | translate"
            attachedDOM="body"
            formControlName="dateField"
            [ranged]="true" />
        </form>
      </div>
      <div class="d-flex align-items-center gap-3">
        @if (showReadOnlyLabel()) {
          <span class="text-muted mt-4">
            {{ 'countryInformation.readOnly' | translate }}
          </span>
        }
        <div *gstarCanEditCountry="countryId()" class="d-flex gap-3">
          <div>
            <ap-button
              class="mt-4"
              btnType="secondary"
              [label]="'portfolio.import.buttonLabel' | translate"
              [loading]="importLoading()"
              [isLoading]="importLoading()"
              (onClick)="importFile()"
              ap-tooltip
              [tooltipContent]="importLoading() ? tooltip : null"
              direction="top"
              icon="upload-outline" />
            <ng-template #tooltip>
              <div>{{ 'notifications.fileProcessing' | translate }}</div>
            </ng-template>
          </div>
          <div>
            <ap-button
              btnType="primary"
              icon="plus-outline"
              [label]="'countryInformation.news' | translate"
              (onClick)="addTaxNews()" />
          </div>
        </div>
      </div>
    </div>

    <div class="tax-results-container shadow d-flex flex-wrap rounded">
      @for (item of taxNews(); track $index) {
        <gstar-tax-news-card
          (click)="goToDetails(item.countryTaxNewsId ?? 0)"
          (reloadNews)="fetchNews()"
          [class.clickable]="!canEditCountry()"
          class="col-12 col-md-6 col-lg-4 p-3"
          [taxNews]="item"
          [isGrid]="true"></gstar-tax-news-card>
      }
      @if (taxNews().length === 0) {
        <div class="col-12">
          <strong class="d-flex justify-content-center m-3">
            @if (dateField.value.length === 0) {
              {{ 'countryInformation.noTaxNews' | translate }}
            } @else {
              {{ 'countryInformation.noTaxNewsDate' | translate }}
            }
          </strong>
        </div>
      }
    </div>
    <gstar-grid-footer
      #footer
      [data]="taxNews()"
      [paginationSetting]="pagination"
      [options]="options"
      (pageChange)="pageChange($event)" />
  }
</div>
